import { EEntityType } from '@/editor/types';
import { EContainerType } from '@/editor/types/entity';
import { RoomData } from '@/editor/data/room/Room';
import RegionModel from './regionModel';

class RoomModel extends RegionModel {
  constructor(roomData: RoomData) {
    super(roomData);
    this.model.userData.type = EEntityType.Room;
    this.model.userData.containerType = EContainerType.entity;
    this.model.userData.entityId = this._id;
  }
}

export default RoomModel;
